import FacturesPrintController from './factures.print.controller';
import factureTemplate from './factures.print.html';

export default {
	bindings: {
		modalInstance: '=',
		resolve: '='
	},
	template: factureTemplate,
	controller: FacturesPrintController
};
